<div class='modal' id='modal_wrapper'>
    <div id='modal_block' class='popup_bg_modal'></div>
    <div id='modal_block_text' class='hidden'>Please wait <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner></div>
    <div id='modal_wrap' class='modal-dialog {{alertService.size}}'>
      <div class='modal-content modal-content-v2'>

        <!-- Modal Header -->
        <div class='modal-header'>
            <h3 class="{{alertService.title_color}}"> 
                <mat-icon aria-hidden="true" *ngIf="alertService.title_icon">{{ alertService.title_icon }}</mat-icon> &nbsp;
                <label id='modal_title' class='modal-title font-18' [innerHTML]="alertService.title"></label>
            </h3>
         
          <button *ngIf="!alertService.syncing()" id='modal_close' type='button' class='close' (click)="onClose()">&times;</button>
        </div>

        <!-- Modal body -->
        <div id='modal_body' class='modal-body'>
            <div *ngIf="alertService.loading()">
                <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner> Cargando...
            </div>
            <div *ngIf="!alertService.loading()" [innerHTML]="alertService.body">
            </div>
        </div>

        <!-- Modal Footer -->
        <div id='modal_footer' class='modal-footer text-right' *ngIf="alertService.showFooter">
          <div *ngIf="alertService.syncing()">
            <mat-progress-spinner mode="indeterminate" diameter="18" aria-label="Cargando"></mat-progress-spinner> Espere...
          </div>  
          <ul *ngIf="!alertService.syncing()">
                <li *ngFor="let button of alertService.buttons">
                    <button class='btn {{button.btn_class}}' (click)="button.onClick()" [appBtnAutoFocus]=button.focus><mat-icon *ngIf="button.icon" aria-hidden="true">{{ button.icon }}</mat-icon> {{button.title}}</button>
                </li>
            </ul>
        </div>

        <div id='modal_msg' class='modal_msg_wrapper'></div>

      </div>
    </div>
  </div>
